"use strict";
exports.__esModule = true;
var angular = require("angular");
var config_1 = require("../../../config");
require('./psw-login.component.css');
var COMPONENT_NAME = 'smartorg.r6.views.pswLogin';
var USERNAME_COOKIE_KEY = 'wb_name';
var NO_HEADER_ERROR = 'No authentication info or authentication expired.';
var PswLoginComponent = /** @class */ (function () {
    function PswLoginComponent($cookies, $location, $timeout) {
        this.$cookies = $cookies;
        this.$location = $location;
        this.$timeout = $timeout;
        this.azureUrl = config_1.BACKEND_DOMAIN + "/" + config_1.API_ENDPOINT + "/framework/login/c";
    }
    PswLoginComponent.prototype.$onInit = function () {
        var savedUsername = this.$cookies.get(USERNAME_COOKIE_KEY);
        if (savedUsername) {
            this.username = savedUsername;
        }
    };
    PswLoginComponent.prototype.onSuccessLogin = function () {
        this.errorMessage = null;
        if (this.rememberCheck) {
            this.rememberUsername(this.username);
        }
        else {
            this.$cookies.remove(USERNAME_COOKIE_KEY);
        }
        this.loggingIn = false;
    };
    PswLoginComponent.prototype.onErrorLogin = function (errorMessage) {
        this.errorMessage = errorMessage;
        this.loggingIn = false;
        this.$timeout();
    };
    PswLoginComponent.prototype.rememberUsername = function (username) {
        var expires = new Date();
        expires.setDate(expires.getDate() + 14);
        this.$cookies.put(USERNAME_COOKIE_KEY, username, { expires: expires });
    };
    PswLoginComponent.prototype.login = function () {
        var ctrl = this;
        this.loggingIn = true;
        this.$timeout();
        if (!this.username || !this.password) {
            this.onErrorLogin('Please enter username and password.');
            return;
        }
        var _a = this, username = _a.username, password = _a.password;
        this.smartorgApi.authenticate({
            username: username,
            password: password
        }).then(function (userInfo) {
            ctrl.smartorgApi.protocols.credentials.isAdmin = userInfo.is_admin;
            ctrl.smartorgApi.protocols.credentials.username = userInfo.username;
            ctrl.onSuccessLogin();
            ctrl.$location.path('/firstpage');
            ctrl.$timeout();
        })["catch"](function (err) {
            if (err === NO_HEADER_ERROR) {
                ctrl.onErrorLogin('Error logging in, either header missing or database down. Please contact Administrator.');
            }
            else if (err.status === 403) {
                ctrl.onErrorLogin('Username or password does not match our record!');
            }
            else {
                ctrl.onErrorLogin(err);
            }
        });
    };
    return PswLoginComponent;
}());
exports.PswLoginComponent = PswLoginComponent;
angular.module(COMPONENT_NAME, []).component('pswLogin', {
    template: require('./psw-login.component.html'),
    bindings: {
        currentVersion: '@',
        loginDisabled: '<?',
        smartorgApi: '='
    },
    controller: PswLoginComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=psw-login.component.js.map


// WEBPACK FOOTER //
// ./app/views/login2/psw-login/psw-login.component.js